module.exports = __webpack_public_path__ + "img/9788989571964.9f38e30e.jpg";